module.exports = __webpack_public_path__ + "img/shipping_type_1.f355c86.webp";